import { Injectable, inject } from '@angular/core';
import { BaseQueryRepository } from '../query-repository/query.repository';
import {
  DocumentMetadataResponse,
  FindFreightForShipperQuery,
  FindFreightForShipperQueryHandler,
  FreightBasicForShipperResponse,
  FreightDetailForShipperResponse,
  SearchDocumentMetadataQuery,
  SearchFreightsForShippersQueryHandler,
  SearchInProgressFreightsQuery,
  SearchNotInProgressFreightsQuery,
} from '@okcargo/query-processor';
import { DocumentMetadataQueryService } from '../document-metadata';
import { Observable, from } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FreightShipperQueryService {
  private readonly queryRepository = inject(BaseQueryRepository);
  private readonly documentMetadataQueryService = inject(DocumentMetadataQueryService);

  private readonly searchFreightsForShippersQueryHandler: SearchFreightsForShippersQueryHandler;

  private readonly findFreightForShipperQueryHandler: FindFreightForShipperQueryHandler;

  constructor() {
    const queryRepository = this.queryRepository;

    this.searchFreightsForShippersQueryHandler = new SearchFreightsForShippersQueryHandler(queryRepository);

    this.findFreightForShipperQueryHandler = new FindFreightForShipperQueryHandler(queryRepository);
  }

  // TODO first, add query filter here
  // TODO then, refactor this, use only one query, move search criteria to application layer
  public async searchInProgressFreights(
    query: SearchInProgressFreightsQuery,
  ): Promise<FreightBasicForShipperResponse[]> {
    const response = await this.searchFreightsForShippersQueryHandler.handle(query);
    return response.items as FreightBasicForShipperResponse[];
  }

  public async searchFinishedFreights(
    query: SearchNotInProgressFreightsQuery,
  ): Promise<FreightBasicForShipperResponse[]> {
    return this.searchFreightsForShippersQueryHandler
      .handle(query)
      .then((response) => response.items as FreightBasicForShipperResponse[]);
  }

  public findFreight(query: FindFreightForShipperQuery): Observable<FreightDetailForShipperResponse> {
    return from(this.findFreightForShipperQueryHandler.handle(query));
  }

  public searchDocumentMetadata(query: SearchDocumentMetadataQuery): Promise<DocumentMetadataResponse[]> {
    return this.documentMetadataQueryService.searchDocumentMetadata(query);
  }
}
